import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const useAffiliateTracking = () => {
  const location = useLocation()
  const isDevEnv = process.env.REACT_APP_DEV_ENV === "true"

  useEffect(() => {
    if (isDevEnv) return

    const searchParams = new URLSearchParams(location.search)
    const afmc = searchParams.get("afmc")

    if (afmc) {
      localStorage.setItem("affiliateCode", afmc)
    }
  }, [location.search, isDevEnv])
}

export default useAffiliateTracking